import * as Yup from 'yup';
import { REQUIRED_ERROR_MSG } from 'utils/constants/errors';
import { isPossiblePhoneNumber } from 'react-phone-number-input';

export const addClientSchema = Yup.object()
  .shape({
    firstName: Yup.string().required(REQUIRED_ERROR_MSG),
    lastName: Yup.string().required(REQUIRED_ERROR_MSG),
    email: Yup.string()
      .email('Please enter a valid email')
      .required(REQUIRED_ERROR_MSG),
    inviteBySMS: Yup.string(),
    inviteByEmail: Yup.string(),
    phoneNumber: Yup.string().when('inviteBySMS', {
      is: 'inviteBySMS',
      then: Yup.string()
        .required(REQUIRED_ERROR_MSG)
        .test('possiblePhoneTest', null, function test(val) {
          if (isPossiblePhoneNumber(val)) return true;

          return new Yup.ValidationError(
            'Please enter a valid phone number',
            null,
            this.path
          );
        })
    }),
    measurementUnit: Yup.string().required(REQUIRED_ERROR_MSG)
  })
  .test('validateOneCheckbox', null, values => {
    if (
      values.inviteByEmail === 'inviteByEmail' ||
      values.inviteBySMS === 'inviteBySMS'
    ) {
      return true;
    }

    return new Yup.ValidationError(
      'Please check at least one checkbox',
      null,
      'addClientCheckboxes'
    );
  });
